module.exports = __webpack_public_path__ + "img/SpadefootQuiz_C.cce93282.png";